<div class="m-character-count">
    <m-accordion-transition :disabled="!transition">
        <div v-if="hasCounter"
             class="m-character-count__wrap"
             aria-hidden="true"
             aria-live="polite"><span>{{ valueLength }}</span>/{{ maxLength }}</div>
    </m-accordion-transition>
</div>
